import ExploreQpage from '../components/exploreQuiz/ExploreQpage';
import Navbar from '../components/navbar/Navbar';

export default function ExploreExam() {
    return (
        <>
            <Navbar />
            <ExploreQpage />
        </>
    );
}
